/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.applicationModule', [])
.controller('ApplicationController', ['currentUser','$scope','$state','$stateParams','$translate','Restangular','BulbBusyService','BulbErrorService','BulbModalService', ApplicationController]);

function ApplicationController(currentUser, $scope, $state, $stateParams, $translate, Restangular, BulbBusyService,
                 BulbErrorService, BulbModalService) {
  var that = this;

  this.currentUser = currentUser;
  this.state = cleanStateName();

  // This is a helper function that changes any special characters in the state name to a simple '-' so that they
  // can properly be used in the scss files.
  function cleanStateName() {
    return $state.current.name.replace(/[^a-zA-Z0-9]/g, '-');
  }

  $scope.$on('$stateChangeSuccess', function () {
    that.state = cleanStateName();
  });

  if ($stateParams.verifyEmail && this.currentUser.email) {
    this.verifyEmail = this.currentUser.email;
  }

  /**
   * Helper method to wrap the provided string within an html span tag.
   * @param value Value to be wrapped.
   * @returns {string} Value wrapped within a span.
   */
  this.wrapInSpan = function(value) {
    return '<span>' + value + '</span>';
  };

  /**
   * Resend the email verification email.
   */
  this.resendEmailVerification = function() {
    BulbBusyService.showBusyDuring(
      Restangular.one('accounts', that.currentUser.id).customOperation('post', 'sendEmailVerification').then(
        function(testLink) {
          // DO LATER : need to show testLink for automated tests to use.
          var email = that.wrapInSpan(that.currentUser.pendingEmail || that.currentUser.email);
          $translate('account_settings_verify_email_resent', {email: email}).then(function(bodyText) {
            var modalOptions = {
              titleCode: 'account_settings_verify_email_title',
              bodyText: bodyText,
              showOkButton: false,
              showCancelButton: false
            };
            BulbModalService.show(modalOptions);
          });
        }, function(error) {
          BulbErrorService.error('Cannot send email verification', error);
        })
    );
  };
}


